import type { ParticipantTaskTemplate } from '@piccolohealth/pbs-common';
import { ChakraV3, Empty, Spin } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { FormSection } from '../../components/forms/FormSection';
import { showModal } from '../../components/generic/Modal';
import { PiccoloError } from '../../components/generic/PiccoloError';
import { useParticipantTaskTemplatesQuery } from '../../graphql/hooks/useParticipantTaskTemplatesQuery';
import { useAppContext } from '../../hooks/useAppContext';
import { ParticipantTaskTemplateCreateModal } from './taskTemplates/ParticipantTaskTemplateCreateModal';
import { ParticipantTaskTemplateItem } from './taskTemplates/ParticipantTaskTemplateItem';

export const TaskTemplateSettings = () => {
  const { organization } = useAppContext();

  const { data, isLoading, error } = useParticipantTaskTemplatesQuery({
    organizationId: organization.id,
  });

  const taskTemplates = (data?.organization?.participantTaskTemplates ??
    []) as ParticipantTaskTemplate[];

  const onClickAddTaskTemplate = () => {
    showModal(ParticipantTaskTemplateCreateModal);
  };

  const content = P.run(() => {
    if (isLoading) {
      return <Spin showAfterDuration={2000} />;
    }

    if (error) {
      return <PiccoloError error={error} />;
    }

    if (P.isEmpty(taskTemplates)) {
      return <Empty h='full' title='No tasks created yet' p={0} />;
    }

    return (
      <>
        {taskTemplates.map((taskTemplate) => (
          <ParticipantTaskTemplateItem key={taskTemplate.id} taskTemplate={taskTemplate} />
        ))}
      </>
    );
  });

  return (
    <FormSection
      heading='Task template'
      description='Create and manage task templates for participants'
      maxW='md'
    >
      <ChakraV3.Separator />
      <ChakraV3.Stack gap={3} w='full' mb={6}>
        {content}
        <ChakraV3.Button onClick={onClickAddTaskTemplate} size='sm' variant='subtle'>
          <FaPlus />
          Create task template
        </ChakraV3.Button>
      </ChakraV3.Stack>
    </FormSection>
  );
};
